module.exports = __webpack_public_path__ + "img/maitin.6a4664cb.png";